let $ = require('jquery');

function addErrorHandler(img) {
  $(img).on('error', function () {
    $(this).addClass('img-error');
  });
}

function handleBrokenImages() {
  // Attach to existing images
  $('img').each(function () {
    addErrorHandler(this);
  });

  // Observe for new images added to the DOM
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      $(mutation.addedNodes).find('img').each(function () {
        addErrorHandler(this);
      });
      // If an img is added directly
      $(mutation.addedNodes).filter('img').each(function () {
        addErrorHandler(this);
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

export default handleBrokenImages;
